/* global console */
//import * as logger from "./../logger/logger";

function extractEmails(text) {
  return text.match(/([a-zA-Z0-9._+-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
}

export function parseJson(json) {
  // Try to parse the JSON.
  try {
    return JSON.parse(json);
  } catch {
    console.error(json + " is not a valid json");
    return null;
  }
}

export function fillAddress(adresses) {
  var adressesString = "";
  if (adresses.length > 0) {
    adresses.forEach(function (value) {
      var emails = extractEmails(value.emailAddress);
      emails.forEach(function (em) {
        adressesString += em + ",";
      });
    });
  }
  return adressesString;
}

export function limit(string = "", limit = 0) {
  return string.substring(0, limit).concat("...");
}
